"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var CSSOM = require("cssom"),
    myClassName = "simple-svg",
    SimpleSVG = {
  render: function render(e) {
    return e("div", {
      class: ["simple-svg-wrapper"]
    });
  },
  name: "simple-svg",
  props: {
    filepath: String,
    fill: String,
    stroke: String,
    width: String,
    height: String,
    id: {
      type: String,
      defualt: ""
    }
  },
  data: function data() {
    return {
      isSVGReady: !1
    };
  },
  mounted: function mounted() {
    this.generateInlineSVG();
  },
  watch: {
    filepath: function filepath(e) {
      this.generateInlineSVG();
    },
    fill: function fill(e) {
      this.updateSVGStyle("fill", e);
    },
    stroke: function stroke(e) {
      this.updateSVGStyle("stroke", e);
    },
    width: function width(e) {
      this.updateSVGStyle("width", e);
    },
    height: function height(e) {
      this.updateSVGStyle("height", e);
    }
  },
  methods: {
    isClassSelector: function isClassSelector(e) {
      return !!new RegExp(/^\./, "i").test(e);
    },
    removeStyleTag: function removeStyleTag(e) {
      for (var t = e.getElementsByTagName("style")[0], s = CSSOM.parse(t.textContent).cssRules, r = e.getElementsByTagName("*"), i = 0; i < r.length; i++) {
        for (var n = 0; n < s.length; n++) {
          var l = s[n].selectorText;

          if (this.isClassSelector(l)) {
            var o = l.substring(1);

            if (r[i].classList.contains(o)) {
              r[i].classList.remove(o);

              for (var a = s[n].style, g = 0; g < a.length; g++) {
                var m = a[g],
                    u = a[m];
                r[i].style[m] = u;
              }
            }
          }
        }
      }

      return t.parentNode.removeChild(t), e;
    },
    removeFillStrokeStyles: function removeFillStrokeStyles(e) {
      for (var t = e.getElementsByTagName("*"), s = 0; s < t.length; s++) {
        if (void 0 !== t[s].style) {
          var r = t[s].style.fill;
          r && "none" !== r && (t[s].style.fill = "");
          var i = t[s].style.stroke;
          i && "none" !== i && (t[s].style.stroke = "");
        }
      }
    },
    generateInlineSVG: function generateInlineSVG() {
      var e = this;
      this.isSVGReady = !1;
      var t = this.$el.getElementsByTagName("svg")[0];
      t && this.$el.removeChild(t);
      var s = new XMLHttpRequest();
      s.open("GET", this.filepath, !0), s.onload = function () {
        if (s.status >= 200 && s.status < 400) {
          var t = new DOMParser().parseFromString(s.responseText, "text/xml").getElementsByTagName("svg")[0];
          if (!t) return void console.error("No svg element found. Did you pass a valid .svg file?");
          t.getElementsByTagName("style")[0] && (t = e.removeStyleTag(t)), e.removeFillStrokeStyles(t), t.removeAttribute("xmlns:a"), t.removeAttribute("width"), t.removeAttribute("height"), t.removeAttribute("x"), t.removeAttribute("y"), t.removeAttribute("enable-background"), t.removeAttribute("xmlns:xlink"), t.removeAttribute("xml:space"), t.removeAttribute("version"), e.id && (t.id = e.id), t.style.width = e.width, t.style.height = e.height, t.style.fill = e.fill, t.style.stroke = e.stroke, t.classList.add(myClassName), e.$el.appendChild(t), this.isSVGReady = !0, e.$emit("ready");
        } else console.error("There was an error retrieving the source of the SVG.");
      }, s.onerror = function () {
        console.error("There was an error connecting to the origin server.");
      }, s.send();
    },
    updateSVGStyle: function updateSVGStyle(e, t) {
      var s = this.$el.getElementsByTagName("svg")[0];
      s ? s.style[e] = t : console.error("No svg element found. Did you pass a valid .svg file?");
    }
  }
},
    plugin = {
  install: function install(e, t) {
    e.component("simple-svg", SimpleSVG);
  }
};

exports.default = plugin, exports.SimpleSVG = SimpleSVG;